import React from 'react';
import {
  Card,
  CardContent,
  makeStyles,
  Modal,
  Box,
  Container
} from '@material-ui/core';
import { get } from 'lodash';
import parseYoutubeUrlForId from '../utils/youtube-url-parser';
import YoutubePlayer from './YoutubePlayer';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const useStyles = makeStyles(theme => ({
  videoPlayer: {
    marginTop: '2rem',
    width: '800px',
    height: '40vh',
    minHeight: '300px',
    marginBottom: '2rem',
    borderRadius: 0
  },
  videoLoading: {
    width: '800px',
    height: '40vh',
    display: 'grid',
    placeItems: 'center'
  },
  hide: {
    display: 'none'
  },
  card: {
    width: 'fit-content',
    height: 'fit-content',
    borderRadius: 0
  },
  mainSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'nowrap',
    width: '100%'
  },
  popupModal: {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    overflow: 'auto',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    display: 'grid',
    placeItems: 'center',
    margin: 0,
    padding: 0
  }
}));

function YoutubePlayerModal(props) {
  const classes = useStyles();

  function handleClose() {
    props.handleClose();
  }

  return (
    <Modal
      open={props.open}
      onClose={handleClose}
      aria-labelledby="video-player-modal"
      style={{
        display: 'grid',
        placeItems: 'center',
        width: '100%',
        height: '100%'
      }}
    >
      <Container classes={{ root: classes.popupModal }} maxWidth={false}>
        <Card
          classes={{
            root: clsx({
              [classes.card]: !props.classes.root,
              [props.classes.root]: !!props.classes.root
            })
          }}
        >
          <CardContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              padding: 0
            }}
          >
            {props.headerComponent ?? null}
            <Box classes={{ root: classes.mainSection }}>
              {props.leftComponent ?? null}
              <YoutubePlayer
                classes={{
                  root: clsx({
                    [get(props.YoutubePlayerProps, 'classes.root')]: !!get(
                      props.YoutubePlayerProps,
                      'classes.root'
                    ),
                    [classes.videoPlayer]: !get(
                      props.YoutubePlayerProps,
                      'classes.root'
                    )
                  }),
                  controlButtonLeft: clsx({
                    [classes.hide]: !get(
                      props.YoutubePlayerProps,
                      'classes.controlButtonLeft'
                    ),
                    [get(
                      props.YoutubePlayerProps,
                      'classes.controlButtonLeft'
                    )]: !!get(
                      props.YoutubePlayerProps,
                      'classes.controlButtonLeft'
                    )
                  }),
                  controlButtonRight: clsx({
                    [classes.hide]: !get(
                      props.YoutubePlayerProps,
                      'classes.controlButtonRight'
                    ),
                    [get(
                      props.YoutubePlayerProps,
                      'classes.controlButtonRight'
                    )]: !!get(
                      props.YoutubePlayerProps,
                      'classes.controlButtonRight'
                    )
                  }),
                  playerContainer: clsx({
                    [get(
                      props.YoutubePlayerProps,
                      'classes.playerContainer'
                    )]: get(props.YoutubePlayerProps, 'classes.playerContainer')
                  }),
                  loading: classes.videoLoading
                }}
                hide={!props.videoLink}
                src={parseYoutubeUrlForId(props.videoLink)}
              />
              {props.rightComponent ?? null}
            </Box>
            {props.footerComponent ?? null}
          </CardContent>
        </Card>
      </Container>
    </Modal>
  );
}

YoutubePlayerModal.propTypes = {
  videoLink: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  YoutubePlayerProps: PropTypes.object,
  classes: PropTypes.object,
  headerComponent: PropTypes.object,
  leftComponent: PropTypes.object,
  rightComponent: PropTypes.object,
  footerComponent: PropTypes.object
};

YoutubePlayerModal.defaultProps = {
  YoutubePlayerProps: {},
  classes: {}
};

export default YoutubePlayerModal;
